export enum SMTPSecure {
    Tls = 'tls',
}